import {
    Directive, inject, HostBinding
} from "@angular/core";
import { COMMON_APP_SERVICE } from "../../constants/app-tokens";

/**
 * Should be attached to either a single row mat-toolbar, or multi-row mat-toolbar-row.
 * Provides consistent spacing and styling for toolbar elements.
 * Applies mgd-fullscreen class when app is in fullscreen mode.
 *
 * @example
 * <mat-toolbar mgdToolbarRow>
 *   <h2>Title</h2>
 *   <span mgdToolbarInfo><mat-icon>access_time</mat-icon>2025-01-19</span>
 *   <button mat-raised-button>Cool</button>
 * </mat-toolbar>
 */
@Directive({
    selector: "[mgdToolbarRow]",
    host: {
        class: "mgd-toolbar-row"
    }
})
export class ToolbarRowDirective {

    private readonly _app = inject(COMMON_APP_SERVICE);

    @HostBinding("class.mgd-fullscreen")
    get isFullscreen(): boolean {
        return this._app.fullscreen;
    }

    @HostBinding("class.mgd-sidenav-open")
    get isSidenavOpen(): boolean {
        return !this.isFullscreen;
    }
}
